import React from 'react';
import { Link } from 'react-router-dom';

const HomeSidebarFooterLinks = () => {

   return (
      <div className="home_footer">
        <div className="nav_menu">
          <Link to="/privacy"> Privacy </Link>
          <Link to="/cookie-notice"> Cookie Notice</Link>
          <Link to="/terms"> Terms of Service</Link>
        </div>
      </div>
  );
};

export default HomeSidebarFooterLinks;

